import { useState } from "react";
import {
  Autocomplete,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  FormControl,
  Grid,
  TextField,
} from "../../../../../components";
import { EnderecoService, notification } from "../../../../../services";
import { responseErros } from "../../../../../utils";
import { InputErros, value } from "../../../../../helpers";

const enderecoService = new EnderecoService();

function EnderecoClienteEstabelecimentoDialog({
  open,
  setOpen,
  nfSaidaEntity,
  listaEstados,
}) {
  const [ufId, setUfId] = useState(null);
  const [cidades, setCidades] = useState([]);
  const [cidadeId, setCidadeId] = useState(null);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const changeCidadesByEstadoId = async (id) => {
    if (id) {
      enderecoService.getCidades(id).then((response) => {
        if (!response.isAxiosError) {
          if (!response.data) {
            notification.erroValidacao("Preencha um estado");
          } else {
            setCidades(response.data);
          }
        } else {
          responseErros(response);
        }
      });
    }
  };

  const handleEstadoUfInput = async (e, newValue) => {
    e.persist();
    setUfId(newValue?.id || null);
    if (newValue?.id) {
      changeCidadesByEstadoId(newValue.id);
    }
  };

  const handleCidadeInput = (e, newValue) => {
    e.persist();
    setCidadeId(newValue?.id || null);
  };

  function informarMunicipioDeConsumo() {
    if (!cidadeId && !ufId) {
      notification.erroValidacao("Preencha o estado e a cidade");
    }
    const codigoMunicioConsumo = cidades.find(
      (cidade) => cidade.id === cidadeId,
    )?.codigoIbge;
    nfSaidaEntity.setCodigoMunicipioConsumo(codigoMunicioConsumo);
  }

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
      open={open}
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "0.7rem",
          background: "white",
        },
      }}
    >
      <form onSubmit={() => informarMunicipioDeConsumo()}>
        <DialogContent>
          <CardHeader title="INFORME O MUNICÍPIO DE CONSUMO" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl variant="outlined" margin="normal" fullWidth>
                  <Autocomplete
                    required
                    id="estado"
                    name="estado"
                    options={listaEstados}
                    noOptionsText="Sem opções"
                    autoHighlight
                    getOptionLabel={(option) =>
                      option.sigla && option.nome
                        ? `${option.sigla} - ${option.nome}`
                        : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="UF"
                        required
                        variant="outlined"
                        error={inputErros.get("bairro")}
                      />
                    )}
                    onChange={(event, newValue) =>
                      handleEstadoUfInput(event, newValue)
                    }
                    value={value.autoComplete(listaEstados, ufId)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl variant="outlined" margin="normal" fullWidth>
                  <Autocomplete
                    required
                    id="cidade"
                    name="cidade"
                    options={cidades}
                    noOptionsText="Sem opções"
                    autoHighlight
                    getOptionLabel={(option) =>
                      option.nome ? option.nome : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cidade"
                        required
                        variant="outlined"
                        error={inputErros.get("cidade")}
                      />
                    )}
                    onChange={(event, newValue) => {
                      handleCidadeInput(event, newValue);
                    }}
                    value={value.autoComplete(cidades, cidadeId)}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button
              variant="contained"
              color="padrao"
              onClick={() => setOpen(false)}
            >
              FECHAR
            </Button>
            <Button variant="contained" color="primary" type="submit">
              INFORMAR MUNICÍPIO
            </Button>
          </CardActions>
        </DialogContent>
      </form>
    </Dialog>
  );
}

export default EnderecoClienteEstabelecimentoDialog;
